import { computed, inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { PermissionsService } from '../../app/core/services/permissions.service';

@Injectable({ providedIn: 'root' })
export class AuthPermissionsService {
  protected readonly permissionsService = inject(PermissionsService);

  // Directly consume the signal from PermissionsService, maintaining reactivity
  permissions = computed(() => this.permissionsService.permissions() ?? []);

  anyPermission$ = (required: string[]) =>
    toObservable(this.permissions).pipe(
      filter(permissions => !!permissions?.length),
      map(permissions => required.some(p => permissions.includes(p)))
    );

  anyPermission = (required: string[]) => required.some(p => this.permissions()?.includes(p));
}

export const hasPermissionGuardFn = (requiredPermissions: string[]): CanActivateFn => {
  return () => {
    const authService = inject(AuthPermissionsService);
    const router = inject(Router);

    return authService.anyPermission$(requiredPermissions).pipe(map(hasAccess => (hasAccess ? true : router.parseUrl('/home'))));
  };
};
